module.exports = __webpack_public_path__ + "static/media/fileManager.08026431.svg";